import { regex } from "./regex"

export const validation = {
    isPasswordValid: (password: string): boolean =>
        regex.password.test(password),

    isNameValid: (firstName: string): boolean => regex.name.test(firstName),

    isPhoneValid: (phone: string): boolean => regex.phone.test(phone),

    isEmailValid: (email: string): boolean => regex.email.test(email),

    isUsernameValid: (username: string): boolean =>
        regex.username.test(username),

    isInputEmail: (input: string): boolean => regex.determineEmail.test(input),

    isInputPhone: (input: string): boolean => regex.determinePhone.test(input),

    areAllowedCharsInEmailPhoneInput: (input: string): boolean =>
        regex.allowedCharsInEmailPhoneInput.test(input),

    isDigitsOnly: (input: string): boolean => regex.digitsOnly.test(input),

    isLettersOnly: (input: string): boolean => regex.lettersOnly.test(input),

    isDateOfBirthValid: (date: string): boolean => regex.birth_date.test(date),

    isAtLeast15YearsOld: (date: string): boolean => {
        const today = new Date()
        const birthDate = new Date(date)
        const age = today.getFullYear() - birthDate.getFullYear()
        return age >= 15
    },
}
